import React, { useEffect, useState, useRef, useCallback } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "@assets/css/Services.css";

const Compare = () => {
  const [position, setPosition] = useState(50);
  const isHovered = useRef(false);
  const isDragging = useRef(false);
  const direction = useRef(1);
  const containerRef = useRef(null);
  const animationRef = useRef(null);

  const before = "./images/cars.png";
  const after  = "./images/cars1.png";

  // Auto-animation: rör sig mellan 20% och 80%
  useEffect(() => {
   const animate = () => {
  if (isDragging.current || isHovered.current) return;  // ← lägg till isHovered
  setPosition(prev => {
    let next = prev + direction.current * 0.10;
    if (next >= 80) { direction.current = -1; next = 80; }
    if (next <= 20) { direction.current =  1; next = 20; }
    return next;
  });
};
    animationRef.current = setInterval(animate, 16);
    return () => clearInterval(animationRef.current);
  }, []);

  const getPos = (e) => {
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const rect = containerRef.current.getBoundingClientRect();
    return Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
  };

  const onStart = useCallback((e) => {
    isDragging.current = true;
    setPosition(getPos(e));
    e.preventDefault();
  }, []);

  const onMove = useCallback((e) => {
    if (!isDragging.current) return;
    setPosition(getPos(e));
  }, []);

  const onEnd = useCallback(() => {
    isDragging.current = false;
  }, []);

  useEffect(() => {
    AOS.init();
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onEnd);
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", onEnd);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onEnd);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onEnd);
    };
  }, [onMove, onEnd]);

  return (
    <div className="mainWrapper">
      <div>
        <div className="text_field">
  <div className="compare_heading" data-aos="zoom-in" data-aos-delay="500">
    FRÅN IDÉ TILL GENOMFÖRANDE
  </div>
  </div> 

        <img className="for_mobile" src="./images/cars1.png" alt="" />
      </div>
      <div className="contentWrapper">
        <div
  ref={containerRef}
  style={{ position: "relative", width: "100%", userSelect: "none", cursor: "grab" }}
  onMouseDown={onStart}
  onTouchStart={onStart}
  onMouseEnter={() => isHovered.current = true}   // ← lägg till
  onMouseLeave={() => isHovered.current = false}  // ← lägg till
>
          {/* Höger bild (after) */}
          <img src={after} alt="After" style={{ width: "100%", display: "block" }} />

          {/* Vänster bild (before) – klippt */}
          <div style={{
            position: "absolute", top: 0, left: 0,
            width: `${position}%`, height: "100%", overflow: "hidden",
          }}>
            <img src={before} alt="Before" style={{
              width: containerRef.current ? `${containerRef.current.offsetWidth}px` : "100%",
              maxWidth: "none", display: "block",
            }} />
          </div>

          {/* Linje */}
          <div style={{
            position: "absolute", top: 0, left: `${position}%`,
            transform: "translateX(-50%)", height: "100%",
            width: "2px", backgroundColor: "#0173b2", pointerEvents: "none",
          }}>
            {/* Handtag */}
            <div style={{
              position: "absolute", top: "50%", left: "50%",
              transform: "translate(-50%, -50%)",
              width: "42px", height: "42px", borderRadius: "50%",
              backgroundColor: "#0173b2", display: "flex",
              alignItems: "center", justifyContent: "center",
              color: "white", fontSize: "20px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.5)",
              cursor: "grab",
            }}>⇔</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Compare;